import { createElementBlock as o, openBlock as e, createElementVNode as r } from "vue";
import c from "./index289.js";
const n = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(a, t, p, m, d, f) {
  return e(), o("svg", l, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12 2.25c5.278 0 9.593 4.2 9.746 9.474l.004.276c0 5.278-4.2 9.593-9.474 9.746L12 21.75c-5.278 0-9.593-4.2-9.746-9.474L2.25 12c0-5.278 4.2-9.593 9.474-9.746Zm0 1.5-.244.004c-4.453.128-8.006 3.78-8.006 8.235l.004.255c.128 4.453 3.78 8.006 8.235 8.006l.255-.004c4.453-.128 8.006-3.78 8.006-8.235l-.004-.255A8.25 8.25 0 0 0 12 3.75Zm0 3.5a.75.75 0 0 1 .743.648L12.75 8v3.25H16a.75.75 0 0 1 .102 1.493L16 12.75h-3.25V16a.75.75 0 0 1-1.493.102L11.25 16v-3.25H8a.75.75 0 0 1-.102-1.493L8 11.25h3.25V8a.75.75 0 0 1 .75-.75Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ c(n, [["render", s]]);
export {
  u as default
};
